export const GhostCharacteristics = {
  batteryServiceUuid: 'battery_service',
  batteryLevelUuid: 'battery_level',
  pairingUuid: '00887766-5544-3322-1100-aabbccddeeff',
  deviceUuid: '11887766-5544-3322-1100-aabbccddeeff',
  serviceUuid: 'ffeeddcc-bbaa-0011-2233-445566778899',
  deviceName: {
    uuid: 'ffeeddcc-bbaa-0011-2233-445566778801',
    label: 'Device Name',
    properties: {
      notify: false,
      read: true,
      write: true,
      type: 'string',
    },
  },
  status: {
    uuid: 'ffeeddcc-bbaa-0011-2233-445566778802',
    label: 'Status',
    properties: {
      notify: true,
      read: true,
      write: true,
      type: 'hex',
    },
  },
  bootState: {
    uuid: 'ffeeddcc-bbaa-0011-2233-445566778803',
    label: 'Unknown #2',
    properties: {
      notify: true,
      read: true,
      write: false,
      type: 'hex',
    },
  },
  temperatures: {
    uuid: 'ffeeddcc-bbaa-0011-2233-445566778804',
    label: 'Temperatures',
    properties: {
      notify: true,
      read: true,
      write: true,
      type: 'hex',
    },
  },
  currentProfile: {
    uuid: 'ffeeddcc-bbaa-0011-2233-445566778805',
    label: 'Current',
    properties: {
      notify: true,
      read: true,
      write: true,
      type: 'hex',
    },
  },
  pairingKey: {
    uuid: 'ffeeddcc-bbaa-0011-2233-445566778806',
    label: 'Pairing Key',
    properties: {
      notify: true,
      read: true,
      write: true,
      type: 'hex',
    },
  },
};
